export default __webpack_public_path__ + "static/media/320.8acac987.png";